export function getAssetUrl(url: string) {
  return new URL(url, import.meta.url).href
}

export function fileUrl(file: string) {
  let base = file && file.toLowerCase().includes('http') ? '' : import.meta.env.BASE_URL
  if (base.endsWith('/')) {
    base = base.substring(0, base.length - 1)
  }
  return base + file
}

export function dataUrl(data: string) {
  const normalizedData = normalizeDataPath(data)
  const skip =
    !normalizedData ||
    normalizedData.toLowerCase().includes('http') ||
    normalizedData.startsWith('/images/')
  let base = skip ? '' : import.meta.env.VITE_DATA_URL

  if (isDevApiDataBase(base) && isUploadPath(normalizedData)) {
    base = import.meta.env.VITE_PROXY_TARGET || ''
  }

  base = trimTrailingSlash(base)
  return base + normalizedData
}

export function uploadBase() {
  return import.meta.env.VITE_FILE_UPLOAD_BASE
}

function normalizeDataPath(data: string) {
  if (!data) return ''

  let value = data
  if (value.startsWith('../')) {
    value = value.replace(/^\.\.\//, '/')
  }

  value = value.replace(/^\/?api\/uploads\//, '/uploads/')
  value = value.replace(/^\/?api\/image\//, '/image/')

  if (value.startsWith('uploads/') || value.startsWith('image/')) {
    value = '/' + value
  }

  return value
}

function isUploadPath(data: string) {
  return data.startsWith('/uploads/') || data.startsWith('/image/')
}

function isDevApiDataBase(base: string) {
  return trimTrailingSlash(base) === '/api'
}

function trimTrailingSlash(value: string | undefined) {
  return (value || '').replace(/\/+$/, '')
}
